import { userConstants, profileConstants } from '../constants';
import { userService } from '../services';
import { alertActions } from './';
import { history } from '../helpers';

export const userActions = {
    login,
    logout,
    register,
    updateUser,
    fetchLandingMedia,
    fetchprofileavatars,
    fetchFavActivities,
    updatefavactivity,
    fetchTermsandConditions,
    updateTermsandConditions,
    collectCoin
};

function login(accesscode) {
    return dispatch => {
        dispatch(request({ accesscode }));

        return userService.login(accesscode)
            .then(user => {
                dispatch(success(user));
                return user;
            })
            .catch(error => {
                dispatch(failure(error));
                throw error; 
            });
    };

    function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
    function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
    function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function logout() {
    return dispatch => {
        userService.logout();
        dispatch({ type: userConstants.LOGOUT });
        dispatch({ type: profileConstants.CLEAR_PROFILE });
    };
}

function updateUser(user) {
    return { type: userConstants.UPDATE_USER, user };
}

function register(user) {
    return dispatch => {
        dispatch(request({ user }));

        return userService.register(user)
            .then(
                user => {
                    dispatch(success(user));
                    return user;
                },
                error => {
                    dispatch(failure(error));
                    return Promise.reject(error);
                }
            );
    };

    function request(user) { return { type: userConstants.REGISTER_REQUEST, user } }
    function success(user) { return { type: userConstants.REGISTER_SUCCESS, user } }
    function failure(error) { return { type: userConstants.REGISTER_FAILURE, error } }
}

function fetchLandingMedia() {
    return dispatch => {
        return userService.fetchLandingMedia()
            .then(
                response => {
                    return response;
                },
                error => {
                    return error;
                }
            );
    };
}

function fetchprofileavatars(studentid) {
    return dispatch => {
        dispatch(request());

        userService.fetchprofileavatars(studentid)
            .then(
                response => {
                    dispatch(success(response));
                    return response;
                },
                error => {
                    dispatch(failure(error));
                    // showToast(error.toString(), 'error');
                }
            );
    };

    function request() { return { type: userConstants.FETCH_AVATARS_REQUEST } }
    function success(avatars) { return { type: userConstants.FETCH_AVATARS_SUCCESS, avatars } }
    function failure(error) { return { type: userConstants.FETCH_AVATARS_FAILURE, error } }
}

function fetchFavActivities() {
    return dispatch => {
        return userService.fetchFavActivities()
            .then(
                response => {
                    return response;
                },
                error => {
                    return error;
                }
            );
    };
}

function updatefavactivity(activityDetails) {
    return dispatch => {
        return userService.updatefavactivity(activityDetails)
            .then(
                response => {
                    return response;
                },
                error => {
                    return Promise.reject(error);
                }
            );
    };
}

function fetchTermsandConditions(popupType) {
    return dispatch => {
        return userService.fetchTermsandConditions(popupType)
            .then(
                response => {
                    return response;
                },
                error => {
                    return error;
                }
            );
    };
}

function updateTermsandConditions(submissionData) {
    return dispatch => {
        return userService.updateTermsandConditions(submissionData)
            .then(
                response => {
                    return response;
                },
                error => {
                    return error;
                }
            );
    };
}

function collectCoin(coinData) {
    return dispatch => {

        return userService.collectCoin(coinData)
            .then(
                response => {
                    return response;
                },
                error => {
                    return Promise.reject(error);
                }
            );
    };

}
